export function isFlowMode(value?: string) {
    const trimmed = value?.trim() ?? '';
    return trimmed.startsWith('=');
}
